var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.card.flipped,staticClass:"card",class:{ cardmatch: _vm.card.matched }},[_c('img',{attrs:{"src":_vm.card.image,"height":"160px","width":"180px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.card.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a77f90","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-card-matched.vue
// module id = 147
// module chunks = 0